import "../.././styles/Constitution.css";

function ArticleSix() {
    return(
        <>
            <div className="container">
                <div className="sub-container constitution" >
                    <h3>ARTICLE VI: MEETINGS OF THE CORPORATION</h3>
                    <h5>6.1 Annual General</h5>
                    <ol type="a">
                        <li><p>
                            An Annual General Meeting of the Corporation shall be held on the third week of March in
                            each calendar year in the City of Winnipeg, in Manitoba on a day to be fixed by the
                            Governing Board.
                        </p></li>
                        <li><p>
                            At least 14 days prior to the Annual General Meeting, the Secretary shall notify all Members
                            by mail or by news media of the date, time and place of the meeting and the texts of any
                            resolutions to be debated at such meeting.
                        </p></li>
                        <li><p>
                            No error or omission in giving notice of the Annual General Meeting (or any adjournment of
                            it) will invalidate the meeting or void any proceedings taken at the meeting. Any Member
                            may waive notice of any Annual General Meeting and may ratify any proceeding taken at
                            the meeting.
                        </p></li>
                        <li><p>
                            A quorum at any Annual General Meeting of the Corporation will consist of 10% of those
                            Members in attendance who are entitled to vote as at the date of filing &amp; payment of
                            membership fees, as set by the Governing Board. If a quorum is present when the meeting
                            is called to order, a quorum is deemed to be present throughout the meeting. If a quorum
                            is not present when the meeting is called to order, the Chair shall then fix a new date for an
                            Annual General Meeting, which date shall not be more than 14 days later.
                        </p></li>
                        <li><p>
                            The President of the Corporation shall chair the meeting but shall not be entitled to vote on
                            any question, except to break a tie or second vote.
                        </p></li>
                        <li><p>
                            Proxies shall not be permitted at any Annual General Meeting.
                        </p></li>
                        <li><p>
                            Every question at an Annual General Meeting, except for the election of Members of the
                            Governing Board, shall be decided by a simple majority as indicated by a show of hands. A
                            ballot vote shall be held for the election of Members of the Governing Board and when a
                            motion demanding a ballot vote has been duly passed by a majority of the persons present
                            and entitled to vote on the question.
                        </p></li>
                        <li><p>
                            The business of the Annual General Meeting will be:
                            <ol type="i" className="indent">
                                <li><p>
                                    To receive and consider reports from Members of the Governing Board;
                                </p></li>
                                <li><p>
                                    To receive and consider the report of the independent auditor, if any for the most
                                    recent fiscal year;
                                </p></li>
                                <li><p>
                                    To appoint an independent auditor, whenever necessary, for the next ensuing fiscal
                                    year;
                                </p></li>
                                <li><p>
                                    To elect Members of the Governing Board to fill retired positions since the last
                                    Annual General Meeting; and
                                </p></li>
                                <li><p>
                                    To consider and vote or ratify upon such other matters as are properly brought
                                    before the meeting.
                                </p></li>
                            </ol>
                        </p></li>
                        <li><p>
                            The only persons entitled to be present at an Annual General Meeting are Members in
                            good standing, the independent auditor &amp; legal counsel appointed by the Governing Board.
                            Other persons may only be allowed with the consent of the majority of the Members
                            present at the meeting.
                        </p></li>
                        <li><p>
                            Any ballots cast in the elections of Members of the Governing Board shall be counted by
                            not less than 3 scrutineers appointed by the Board. The results shall be communicated to
                            the Chair of the meeting who shall then announce the results at the said meeting.
                        </p></li>
                    </ol> 
                </div>
            </div>
            <div className="container">
                <div className="sub-container constitution" id="section-even">
                    <h5>6.2 Special Membership Meeting</h5>
                    <ol type="a">
                        <li><p>
                            A special meeting may be convened at such time and place, as determined &amp; ordered
                            Members of the Governing Board.
                        </p></li>
                        <li><p>
                            A Special Membership Meeting shall be convened upon the written request of at least 10%
                            of the current members in good standing. The request shall specify the purpose for which
                            the meeting is desired. If a Special Meeting is called and the Resolution contained within
                            the notice calling the Special Meeting is not approved by the General Membership, those
                            Members requesting the Special Meeting shall, upon the majority vote of Members
                            present, reimburse the Corporation for the expenses reasonably incurred in holding the
                            Special Meeting.
                        </p></li>
                        <li><p>
                            The timing, method, and validity of giving notice, the determination of quorum, the method
                            of voting, and entitlement of persons to be present for a Special Meeting shall be the same
                            as that of the Annual General Meeting.
                        </p></li>
                    </ol>
                </div>
            </div>
            <div className="container">
                <div className="sub-container constitution">
                    <h5>6.3 Governing Board Meetings</h5>
                    <ol type="a">
                        <li><p>
                            Members of the Governing Board shall meet every other month or at least six times per
                            calendar year. The President of the corporation or any five of the Members of the
                            Governing Board may call a special or emergency meeting of the Governing Board.
                        </p></li>
                        <li><p>
                            Unless notice has been waived by all Members of the Governing Board, the
                            Communications Secretary shall send by postal or email to each member setting out the
                            date, time, and place of the meeting, not less than 48 hours prior to the scheduled starting
                            time of the meeting.
                        </p></li>
                        <li><p>
                            If all of the Members of the Governing Board are present, or those absent have given their
                            consent to the meeting being Governing Board shall be a majority, all of whom are
                            personally present or are able to participate in the meeting.
                        </p></li>
                        <li><p>
                            Every question at a Governing Board meeting shall be decided by a simple majority as
                            indicated by a show of funds.
                        </p></li>
                        <li><p>
                            Each Member of the Governing Board, including the President, shall have one vote. In the
                            case of a tie, the President shall break the tie by casting a second vote.
                        </p></li>
                        <li><p>
                            A written resolution signed by all Members of the Governing Board shall be as valid and
                            effective as one passed at a duly convened meeting the Governing Board.
                        </p></li>
                        <li><p>
                            Minutes of Meetings shall be signed by the Chair &amp; Recording Secretary and kept at the
                            administration office in chronological order.
                        </p></li>
                    </ol>
                </div>
            </div>
        </>
    );
}

export default ArticleSix;